import React, {useState, useEffect} from 'react'
import { Container, Row } from 'react-bootstrap'


import "../buidl.css";


function Conclusion() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    // const handleContextMenu = (e) => {
    //   e.preventDefault(); // Disable right-click
    // };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"272A38",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh',
      paddingBottom: isSmallScreen ? '5rem' : 'auto',
       paddingTop: isSmallScreen ? '5rem' : 'auto',
      color: 'white',
      }}>
        <Row style={{ height: "auto", width: "100%"}}>
          <h2 style={{fontWeight:"bold",fontSize:"3rem"}}>Conclusion</h2>
          <p style={{fontSize:"0.88rem"}}>The system streamlines hiring by automating the matching process and reduces friction between founders, project managers, and freelancers. By combining this smart matching with integrated tools for tasks, communication, file sharing, and payments, BUIDL addresses key pain points that existing platforms leave fragmented.</p>

           <p style={{marginTop:"30px", fontSize:"0.88rem"}}>In designing BUIDL, the process was firmly rooted in user needs and feedback. Role-based dashboards, a thoughtful onboarding flow, a centralized workspace, and a transparent wallet interface all flowed from research, prototyping, and iterative testing. The interface strikes a balance between sophistication and clarity making complex capabilities feel accessible and user-friendly, while maintaining consistency and responsiveness across devices.</p>
            <p style={{marginTop:"30px", fontSize:"0.88rem"}}>Looking ahead, BUIDL’s potential rests on its ability to evolve with its user base. Monitoring usage metrics, adapting matching algorithms, expanding integrated services, and iterating on collaboration features will all be critical. If nurtured thoughtfully, BUIDL can become a go-to platform in the decentralized, AI-driven freelance and startup ecosystema bridge between idea and execution that empowers creators to build together more effectively.</p>
        </Row>
       
    </Container>
    
     
    
  )
}

export default Conclusion